<template>
  <v-card :class="[$root.isRTL ? 'fullContentRTL' : 'fullContent']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">settings</i>
        {{$t('settings')}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-title primary-title>
      <v-tabs v-model="selectedTab" input="tabChanged" dark :scrollable="false" style="padding: 20px; padding-bottom: 5px;">
        <v-tabs-bar slot="activators" style="background-color: #fff; border-bottom: 2px solid #F7941D;">
          <v-tabs-item href="#tab-0">חבילות</v-tabs-item>
          <v-tabs-item href="#tab-1">שלבי התקדמות</v-tabs-item>
          <v-tabs-item href="#tab-2">הגדרות מערכת</v-tabs-item>
        </v-tabs-bar>
        <v-tabs-content style="background-color: #fff;" id="tab-0">
              <TablePackages></TablePackages>
        </v-tabs-content>
        <v-tabs-content style="background-color: #fff;" id="tab-1">
          <TableStatuses></TableStatuses>
        </v-tabs-content>
        <v-tabs-content style="background-color: #fff;" id="tab-2">
          <TableSettings></TableSettings>
        </v-tabs-content>
      </v-tabs>
    </v-card-title>
  </v-card>
</template>

<script>

  import imgUser from '../assets/user.png';
  import TablePackages from '../components/TablePackages';
  import TableStatuses from '../components/TableStatuses';
  import TableSettings from '../components/TableSettings';

  export default {
    name: 'Settings',
    components: {
      TablePackages,
      TableStatuses,
      TableSettings
    },
    data() {
      return {
        txtSearch: '',
        customersList: [],
        isDelete: false,
        isEdit: false,
        isNew: false,
        selectedTab: "tab-0",
      }
    },
    created() {
      this.$Log("Vue [Settings] is created ...");
    },
    ready() {
      this.$Log("Vue [Settings] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Settings] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Settings] is updated ...");
    },
    computed: {
    },
    watch: {
    },
    methods: {
    }
  }

</script>
<style>
  .tabs__container {
    position: relative;
  }

  .tabs__li {
    padding-left: 5px !important;
  }
  .tabs__bar {
    /*height: 40px;*/
  }

  a.tabs__item {
    text-transform: none !important;
    background-color: #f2f2f2 !important;
    color: #3A2D01 !important;
    /*border-bottom: 2px solid #F7941D !important;*/
    font-size: 18px;
    letter-spacing: 1px;
    border-radius: 10px 10px 0px 0px;
    border: none;
    display: block;
  }

  a.tabs__item--active {
    text-transform: none !important;
    background-color: #F7941D !important;
    color: #fff !important;
    border: none;
    /*border-bottom: 2px solid #F7941D !important;*/
  }

  .divColor{
    width: 150px;
    height: 25px;
  }

</style>



// WEBPACK FOOTER //
// Settings.vue?5251fe07